import script from "./PTable.vue?vue&type=script&setup=true&lang=js"
export * from "./PTable.vue?vue&type=script&setup=true&lang=js"

import "./PTable.vue?vue&type=style&index=0&id=c561b53a&lang=less"

const __exports__ = script;

export default __exports__